export default [
  {
    path: '/',
    name: 'foravila-home',
    component: () => import('@/views/foravila/bookings/list/BookingsList.vue'),
  },
]
